export default __webpack_public_path__ + "static/media/txt1.732caad4.jpg";